import React from "react";

export const ObjectToPrint = React.forwardRef((props, ref) => {
    return (
      <div ref={ref}><img src={props.src} /></div>
    );
});